import React, { useEffect, useState } from "react"; import { Field, FormikProvider, Form, useFormik, ErrorMessage } from "formik";  
import Menubar from "../Menubar";import { store } from "../../App"; 
import { AiFillFileExcel, AiOutlineSearch, } from "react-icons/ai";import autoTable from "jspdf-autotable"; import {Row, Col, Container } from "react-bootstrap";
import KpiService from "../../Services/KpiService"; import useAlert from "../Alert/useAlert"; import AlertModal from "../Alert/AlertModal";
import {generateYears,  gsdpReportexcel } from "../utils/commonFunctions"; import MasterService from "../../Services/MasterService";

export default function GsdpAssemblyDistrictReport() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();
  const [distlist, setDistrictList] = useState([]); const [Asmblist, setAsmblist] = useState([]); 
  const [EntryData, setEntrydata] = useState(); const [entrydataEnb, setEntrydataEnb] = useState(false); const [DistrictName, setDistrictName] = useState(""); 
  const [MandalName, setMandalname] = useState(""); const [searchText, setSearch] = useState("");
  let username = localStorage.getItem("username"); let roleid = localStorage.getItem("role"); let district = localStorage.getItem("districtid");
  const years = Array.from({ length: 26 }, (_, index) => 22 + index);
const formik = useFormik({ initialValues: { district_id: "", assembly_id:"",mandal_id: "" }, });
useEffect(() => { 
    MasterService.getDistricts().then((res) => { if (res.data) { let options = res.data.map((item, i) => { return ( <option key={i} value={item.id}> {item.value} </option> ); }); setDistrictList(options); } });
 }, []);

 useEffect(() => { if( roleid==="2"){ 
  formik.setFieldValue("district_id",district);
  let params={
    userId: username, 
    districtId: district
  }
  getdata(params) ;
} }, []);
 
  const[unqasmb,setunqasmb] =useState(); const[unqDistricts,setuniqueDistricts] =useState(); const[Asmbnames,setAsmbnames] =useState(); 
const getGsdpAssemblyEstimates = (val) => {
  let params = { 
    userId: username, 
    districtId: val,  
};
getdata(params);
           
};

const getdata=(params)=>{
  store.dispatch({ type: "SHOW_SPINNER" });
  KpiService.getgsdpAssemblyDistrictReport(params).then((res) => {
    if (res.data.SCODE === "01") {
      setEntrydataEnb(true); setEntrydata(res.data.SDESC);
      if(roleid !== "2"){
      setuniqueDistricts([...new Set(res.data.SDESC.map(item => item.district_id))]);
      // const uniqueDistrictAssemblies = [
      //   ...new Map(
      //     res.data.SDESC.map((item) => [
      //       `${item.district_id}-${item.accode_new}`, // Unique key to avoid duplicates
      //       { 
      //         district_id: item.district_id, 
      //         district_name: item.district_name, 
      //         accode_new: item.accode_new, 
      //         acname: item.acname 
      //       }
      //     ])
      //   ).values()
      // ];
      
      // setuniqueDistricts(uniqueDistrictAssemblies);
      
      console.log("...new (res.data.SDESC.map(item => item.district_id))",res.data.SDESC.map(item => item.district_id))
      const DistrictNames = {}; 
      res.data.SDESC.forEach(item => { DistrictNames[item.district_id] = item.district_name; });
      setDistrictName(DistrictNames);
      console.log("DistrictNames",DistrictNames);

      }
     
      
      setunqasmb([...new Set(res.data.SDESC.map(item => item.accode_new))]);
      const asbnames = {};
      res.data.SDESC.forEach(item => { asbnames[item.accode_new] = item.acname; }); setAsmbnames(asbnames);
      console.log("asbnames",asbnames);
    }
    else{ showAlertMessage(res.data.SDESC, "warning",()=>{setEntrydataEnb(false)}); }
  }).catch((err) => { showAlertMessage("Failed to save data. Please try again.", "warning"); 
  }) .finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
}
const getassemblies = (val) => {
    let params = { "userId":username, "districtId":val };
    KpiService.getAssemblies(params).then((res) => { if (res.data) { let options = res.data.SDESC?.map((item, i) => { return ( <option key={i} value={item.accode}> {item.acname} </option> ); }); setAsmblist(options); } });
}
const[asmbenb,setasmbenb] =useState(false);
// const gethoddata=()=>{
//   formik.setFieldValue("assembly_id","0")
//   getGsdpAssemblyEstimates("0") ;
//   setasmbenb(true);
// }
// const getasmb=(value)=>{
  
//   getassemblies(value)
//   setasmbenb(false);
// }
// const getmandals = (val) => {
//     console.log("val",val);
//     let params = {   "userId": username, "districtId": formik.values.district_id, "accode": val };
//     KpiService.getAssemblyMandals(params).then((res) => { if (res.data) { let options = res.data.SDESC?.map((item, i) => { return ( <option key={i} value={item.mandal_code}> {item.mandal_name} </option> ); }); setmndlist(options); } });
// }
  const filteredData = searchText.length > 0 && EntryData?.length ? EntryData.filter((item) => { return ( item && Object.keys(item).some((key) => { const value = item[key]; return ( value !== null && value .toString() .toLowerCase() .includes(searchText.toLowerCase()) ); }) ); }) : EntryData;

  return (
    <>
      <Menubar />
      <Container fluid  className='map-header1'>
        <div className='sa-title'> <h2>GSDP  <span> ASSEMBLY BASED DISTRICT REPORT</span></h2> </div>
      </Container>
      <Container fluid style={{ width: "87%" }} className="outer-page-content-container">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <div className='mandal-container p-4 mt-2'>
              <Row>
                <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}  >
                  <label className="mb-1 fw-bold"> DISTRICT </label> 
                  <span style={{ color: "red" }}> *</span>
                  <Field component="select" 
                  name="district_id" 
                  disabled={roleid==="2"?true:false}
                  className="form-control" onChange={(e) => { getGsdpAssemblyEstimates(e.target.value);formik.handleChange(e) }} > <option value="">--Select--</option> <option value="0">ALL</option>{distlist} </Field>
                  <span style={{ color: "red", fontSize: "13px" }}> <ErrorMessage name="district_id" /> </span>
                </Col>
                {/* <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}  >
                  <label className="mb-1 fw-bold"> ASSEMBLY </label> 
                  <span style={{ color: "red" }}> *</span>
                  <Field component="select" 
                  name="assembly_id" className="form-control" 
                  onChange={(e) => {getGsdpAssemblyEstimates(e.target.value);formik.handleChange(e) }} disabled={asmbenb}> 
                  <option value="">--Select--</option><option value="0">ALL</option> {Asmblist} </Field>
                  <span style={{ color: "red", fontSize: "13px" }}> <ErrorMessage name="assembly_id" /> </span>
                </Col> */}
                {/* {roleid==="2"?
                <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mandal-col" >
                  <label className="mb-1 fw-bold">MANDAL</label> 
                  <span style={{ color: "red" }}> *</span>
                  <Field component="select" 
                  name="mandal_id" className="form-control" 
                  onChange={(e) => {getGsdpAssemblyEstimates(e.target.value);formik.handleChange(e) }} > 
                    <option value="">--Select--</option>     
                    <option value="0">ALL</option> {mndlist} </Field>
                  <span style={{ color: "red", fontSize: "13px" }}> <ErrorMessage name="mandal_id" /> </span>
                </Col>:""} */}
              </Row>
            </div>
        <br />
        {entrydataEnb &&
        <>
      
            <br/>
              <Row>
                                <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3">
                                <div style={{display: "flex",alignItems: "center",border: "1px solid #ddd",borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px",}}
                                        onFocus={(e) => {e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; e.currentTarget.style.border = "1px solid #353935"; e.currentTarget.style.width = "100%";
                                        }}
                                        onBlur={(e) => { e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; e.currentTarget.style.border = "1px solid #ddd"; e.currentTarget.style.width = "150px";
                                        }}
                                    >
                                        <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible", }} />
                                        <input type="text" placeholder="Search" value={searchText}onChange={(event) => setSearch(event.target.value)}
                                            style={{flex: "1",border: "none",outline: "none",fontSize: "1rem",color: "#333",backgroundColor: "transparent",transition: "color 0.3s ease",minWidth: "0",}}/>
                                    </div>
                                </Col>
                                <Col className=" mb-2 " >
                                    <button variant="success" size="sm" type="button" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => gsdpReportexcel("my-table","GsdpAssemblyDistrictReport")} > Excel<AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
                                </Col>
                            </Row>
        
            <div style={{ overflowX: "auto", whiteSpace: "nowrap", maxHeight: "400vh", overflowY: "hidden" }}>        
  <table bordered hover id="my-table" className="table table-bordered custom-table table-responsive sticky-table" >
 <thead>
  <tr className="text-center">
    <th style={{ backgroundColor: "#603913" }}  className="sticky-col sticky-sno" rowSpan={roleid === "2" ? 4 :5}>Sector name</th>
    {/* <th style={{ backgroundColor: "#603913" }}  className="sticky-col sticky-sno" rowSpan={5}>Sector name</th> */}
    <th style={{ backgroundColor: "#603913" }}  className="sticky-col sticky-sector" rowSpan={roleid === "2" ? 4 :5}>Industry</th>
    {(roleid === "2" ?unqasmb : unqDistricts)?.map((mandal) => ( 

        <th key={mandal} style={{ backgroundColor: "#603913" }} colSpan={generateYears().length}> GSDP at Current Prices </th> ))}
  </tr>
  {roleid !== "2" && (
  <tr>
    {unqDistricts?.map((item) => (
      <th key={item.district_id} style={{ backgroundColor: "#603913" }} colSpan={generateYears().length}>
        {`District -${DistrictName[item]}`}
      </th>
    ))}
  </tr>
)}


{/* <tr>
  {roleid === "2" ? (
    <>
      {unqasmb?.map((item) => {
        const assemblyCode = EntryData.find(row => row.accode_new === item)?.accode_new;
        console.log("assemblyCode",assemblyCode, "Asmbnames[assemblyCode]",Asmbnames[assemblyCode]);

        const assemblyName = Asmbnames[assemblyCode] || "";

        return (
          <th key={item} style={{ backgroundColor: "#603913" }} colSpan={generateYears().length}>
            {`Assembly Name - ${assemblyName}`}
          </th>
        );
      })}
    </>
  ) : (
    <>
      {unqDistricts?.map((item) => (
        <th key={item.district_id} style={{ backgroundColor: "#603913" }} colSpan={generateYears().length}>
          {`District - ${item.district_name}, Assembly - ${item.acname || ""}`}
        </th>
      ))}
    </>
  )}
</tr> */}



  <tr>
    {(roleid === "2" ?
        unqasmb : unqDistricts)?.map(
            () => generateYears().map((year) => ( <th key={year} style={{ backgroundColor: "#603913", color: "#fff" }} 
            // className={ year === "2022-23" && ((roleid === "2"? formik.values.assembly_id !== "0" : formik.values.assembly_id !== "0") ? "sticky-col sticky-year" : "") } 
            className={ year === "2022-23" && ((formik.values.district_id !== "0") ? "sticky-col sticky-year" : "") }
            >{year}</th> )) )}
  </tr>
  <tr>
    {(roleid === "2" ?unqasmb : unqDistricts)?.map(() => generateYears().map((year, index) => 
        ( <th key={index}   style={{ backgroundColor: "#603913", color: "white", minWidth: "100px" }} 
          className={ year === "2022-23" && ((formik.values.district_id !== "0") ? "sticky-col sticky-year" : "") }
         > Rs. in Lakhs </th> )) )}
  </tr>
  <tr>
    {(roleid === "2" ?unqasmb : unqDistricts)?.map(() => generateYears().map((year, index) => ( <th key={index} 
    style={{ backgroundColor: "#603913", color: "white" }} 
    // className={ year === "2022-23" && ((roleid === "2"? formik.values.assembly_id !== "0" : formik.values.assembly_id !== "0") ? "sticky-col sticky-year" : "") }
    className={ year === "2022-23" && ((formik.values.district_id !== "0") ? "sticky-col sticky-year" : "") } 
     >{index + 1}</th> )) )}
  </tr>
</thead>

<tbody>
  {(!filteredData || filteredData.length === 0) ? (
    <tr> <td className="text-center" colSpan="9"> <b style={{ color: "red" }}>Details Not Found</b> </td> </tr>
  ) : (
    (() => {
       const groupedData = {}; const displayedKeys = new Set(); 
      filteredData.forEach((detail) => {
        const key = `${detail.bs_name}_${detail.sector_id}`;
        if (!groupedData[key]) {
          groupedData[key] =
           { bs_name: detail.bs_name, sector_id: detail.sector_id, sector_name: detail.sector_name, mandalData: [], };
        }
       
        if ( !groupedData[key].mandalData.some( m =>  m.accode_new === detail.accode_new && m.district_id ===(roleid === "2" ? detail.accode_new : detail.district_id) ) ) 
        { 
        // console.log("accode_new",detail.accode_new,"m.district_id",detail.district_id,"detail",detail);
            groupedData[key].mandalData.push(detail);
         }
      });
    
      const groupedArray = Object.values(groupedData)
   return groupedArray.map((row, i) => {
        const showBsName= !displayedKeys.has(row.bs_name);
        if (showBsName) displayedKeys.add(row.bs_name);
        return (
        
        <tr key={i}>
           <td className="sticky-col sticky-sno" 
           style={{ textAlign: "left", fontWeight: "bold" }} > {showBsName ? row.bs_name : ""} </td>

          <td className="sticky-col sticky-sector" style={{ textAlign: "left" }}> 
            {row.sector_name} </td>
          {row.mandalData.map((mandalDetail, idx) =>
            years.map((year) => {
              const fullYearFormat = `20${year}_${parseInt(year) + 1}`;
              return (
                <td key={`${mandalDetail.accode_new}-${fullYearFormat}`} style={{ textAlign: "right" }} 
                // className={ fullYearFormat === "2022_23" && ((roleid === "2" ? formik.values.assembly_id !== "0" : formik.values.district_id !== "0") ? "sticky-col sticky-year" : "") }
                className={ fullYearFormat === "2022_23" && ((formik.values.district_id !== "0") ? "sticky-col sticky-year" : "") }
                 > 
                {mandalDetail[`gsdp_price_${fullYearFormat}`] || 0} </td>
              );
            })
          )}
        </tr>
     ) });
  })()
)}
</tbody>
</table>
</div>
 </>}
<AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
       </Form>
       </FormikProvider>
      </Container >
    </>
  );
};
